import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import HotelRequestDetails from '../common/hotel/hotel-request-details';
import HotelRequestChips from '../common/hotel/hotel-request-chips';
import RequestPreview from '../common/request/request-preview';
import RequestDetailsSkeleton from '../common/skeleton/request-details-skeleton';
import RequestInfoSkeleton from '../common/skeleton/request-info-skeleton';
import OfferInfo from '../common/offer-info';
import { Panel, PanelHeader, PanelContent } from '../common/panel';

import { renderAttachment } from '../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../middlewares/users-auth.middleware';

const HotelOffer = () => {
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState({
        skeleton: true,
        backdrop: false
    });
    const [hotelOffer, setHotelOffer] = useState(null);
    const [, setError] = useState(null);
    const { id } = useParams();
    let history = useHistory();

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };

    useEffect(() => {
        axios.get(`/api/hoteloffer/${id}`, { headers: headers })
            .then(res => {
                setHotelOffer(res.data);
                setTimeout(() => setLoading({ ...loading, skeleton: false }), 500);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [])

    const deleteOffer = () => {
        setLoading({ ...loading, backdrop: true });
        axios.delete(`/api/hoteloffer/${id}`, { headers: headers })
            .then(res => {
                setTimeout(() => history.push(`/request/${hotelOffer.reservationRequestResource.id}/hotel`), 500);

            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }

    return (
        <>
            {
                loading.backdrop ?
                    <Backdrop className="backdrop" open={loading.backdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    :
                    null
            }
            <Grid container spacing={3}>
                <Grid
                    container item xs={12} md={12} lg={9}
                >
                    <Panel>
                        <PanelHeader>Request Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                hotelOffer ?
                                    <>
                                        <RequestPreview
                                            label={"Hotel"}
                                            keyword={"Hotels"}
                                            reservationRequest={hotelOffer.reservationRequestResource}
                                            Details={
                                                <HotelRequestDetails
                                                    hotelResources={hotelOffer.reservationRequestResource.reservationRequestHotelResources}
                                                />
                                            }
                                            Chips={
                                                <HotelRequestChips
                                                    variant={"default"}
                                                    hotelResources={hotelOffer.reservationRequestResource.reservationRequestHotelResources}
                                                />
                                            }
                                        />
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>

                    <Panel>
                        <PanelHeader>Offer Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                hotelOffer ?
                                    <>
                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Hotel Name:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {hotelOffer.hotelName}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        {
                                            hotelOffer.reservationSupplierHotelAccommodationResources.length > 0 ?
                                                <Grid container item xs={12}>
                                                    <Grid item xs={12} md={3}>
                                                        <Typography variant="button" gutterBottom>
                                                            Accomodation:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid container item xs={12} md={9}>
                                                        <Grid item xs={3}>
                                                            <Typography variant="subtitle2" gutterBottom>
                                                                <b>Rooms:</b>
                                                            </Typography>
                                                        </Grid>
                                                        {
                                                            hotelOffer.reservationSupplierHotelAccommodationResources[0].
                                                                reservationSupplierHotelAccommodationRoomResources.map((room, index) => (
                                                                    <Grid item xs={9} key={index}>
                                                                        <Typography variant="subtitle1" gutterBottom>
                                                                            <b>Room {index + 1} Details</b> <br />
                                                                            Check In: {room.checkIn.replace('T', ' ').substring(0, 16)} <br />
                                                                            Check Out: {room.checkOut.replace('T', ' ').substring(0, 16)} <br />
                                                                            Room Category: {room.roomCategory} <br />
                                                                            Room Type: {room.roomType} <br />
                                                                            Meal Plan: {room.mealPlan} <br />
                                                                            No. of Rooms (Price / Room): {room.noofRooms} ({room.roomPrice} L.E.)
                                                                        </Typography>
                                                                    </Grid>
                                                                ))
                                                        }
                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" display="block" gutterBottom>
                                                                <b>Cancellation Policy:</b>
                                                            </Typography>
                                                            <Typography className="pre-wrap" variant="subtitle1" display="block" gutterBottom>
                                                                {hotelOffer.reservationSupplierHotelAccommodationResources[0].cancellationPolicy}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" display="block" gutterBottom>
                                                                <b>Payment Policy:</b>
                                                            </Typography>
                                                            <Typography className="pre-wrap" variant="subtitle1" display="block" gutterBottom>
                                                                {hotelOffer.reservationSupplierHotelAccommodationResources[0].paymentPolicy}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" display="block" gutterBottom>
                                                                <b>Children Policy:</b>
                                                            </Typography>
                                                            <Typography className="pre-wrap" variant="subtitle1" display="block" gutterBottom>
                                                                {hotelOffer.reservationSupplierHotelAccommodationResources[0].childrenPolicy}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" display="block" gutterBottom>
                                                                <b>Free Policy:</b>
                                                            </Typography>
                                                            <Typography className="pre-wrap" variant="subtitle1" display="block" gutterBottom>
                                                                {hotelOffer.reservationSupplierHotelAccommodationResources[0].freePolicy}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" gutterBottom>
                                                                <b>Attachment:</b>
                                                                {renderAttachment(hotelOffer.reservationSupplierHotelAccommodationResources[0].attachment)}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" gutterBottom>
                                                                <b>Notes:</b>
                                                            </Typography>
                                                            <Typography className="pre-wrap" variant="subtitle1" display="block" gutterBottom>
                                                                {hotelOffer.reservationSupplierHotelAccommodationResources[0].notes}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                :
                                                null
                                        }
                                        {
                                            hotelOffer.reservationSupplierHotelMeetingResources.length > 0 ?
                                                <Grid container item xs={12}>
                                                    <Grid item xs={12} md={3}>
                                                        <Typography variant="button" gutterBottom>
                                                            Meeting Room:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid container item xs={12} md={9}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" gutterBottom>
                                                                <b>Rooms:</b>
                                                            </Typography>
                                                        </Grid>
                                                        {
                                                            hotelOffer.reservationSupplierHotelMeetingResources.map((room, index) => (
                                                                <Grid container item xs={12} key={index}>
                                                                    <Typography variant="subtitle1" display="block" gutterBottom>
                                                                        <b>Room {index + 1} Details</b> <br />
                                                                            Meeting Date/Time: {room.meetingDate.substring(0, 10)} {room.meetingTime.substring(0, 5)} <br />
                                                                            Coffe Break (Time - Price / Person): {renderAttachment(room.coffeeBreakMenu)} {room.coffeeBreakMenu ? <>({room.coffeeBreakTime.substring(0, 5)} - {room.coffeeBreakPrice} L.E./Person)</> : ''}<br />
                                                                            Lunch/Dinner Break (Time - Price / Person): {renderAttachment(room.lunchOrDinnerMenu)} {room.lunchOrDinnerMenu ? <>({room.lunchOrDinnerTime.substring(0, 5)} - {room.lunchOrDinnerPrice} L.E./Person)</> : ''}<br />
                                                                            Room Name: {room.meetingRoomName} <br />
                                                                            Room Capacity: {room.meetingRoomCapacity} <br />
                                                                            Room Setup: {room.roomSetup} <br />
                                                                            Meeting Package Price: {room.meetingPackagePrice} L.E.
                                                                    </Typography>

                                                                    {
                                                                        room.reservationSupplierHotelMeetingEquipmentResources.length > 0 ?
                                                                            <Grid item xs={12}>
                                                                                <Typography variant="subtitle2" display="block" gutterBottom>
                                                                                    <b>Equipments:</b>
                                                                                </Typography>
                                                                                <Typography variant="subtitle1" display="block" gutterBottom>
                                                                                    {
                                                                                        room.reservationSupplierHotelMeetingEquipmentResources.map((item, index) => (
                                                                                            <div key={index}>
                                                                                                {item.equipmentName} - {item.availableItems} items ({item.itemPrice} L.E. / item)
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                </Typography>
                                                                            </Grid>
                                                                            : null
                                                                    }

                                                                    <Grid item xs={12}>
                                                                        <Typography variant="subtitle2" display="block" gutterBottom>
                                                                            <b>Cancellation Policy:</b>
                                                                        </Typography>
                                                                        <Typography className="pre-wrap" variant="subtitle1" display="block" gutterBottom>
                                                                            {room.cancellationPolicy}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12}>
                                                                        <Typography variant="subtitle2" display="block" gutterBottom>
                                                                            <b>Payment Policy:</b>
                                                                        </Typography>
                                                                        <Typography className="pre-wrap" variant="subtitle1" display="block" gutterBottom>
                                                                            {room.paymentPolicy}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12}>
                                                                        <Typography variant="subtitle2" display="block" gutterBottom>
                                                                            <b>Free Policy:</b>
                                                                        </Typography>
                                                                        <Typography className="pre-wrap" variant="subtitle1" display="block" gutterBottom>
                                                                            {room.freePolicy}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12}>
                                                                        <Typography variant="subtitle2" gutterBottom>
                                                                            <b>Attachment:</b>
                                                                            {renderAttachment(room.attachment)}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12}>
                                                                        <Typography variant="subtitle2" gutterBottom>
                                                                            <b>Notes:</b>
                                                                        </Typography>
                                                                        <Typography className="pre-wrap" variant="subtitle1" display="block" gutterBottom>
                                                                            {room.notes}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            ))
                                                        }
                                                    </Grid>
                                                </Grid>
                                                : null
                                        }
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>
                </Grid>

                <Grid
                    container item xs={12} md={12} lg={3}
                >
                    <div className="side-info">
                        {
                            loading.skeleton ?
                                <RequestInfoSkeleton />
                                :
                                hotelOffer ?
                                    <OfferInfo offer={hotelOffer} deleteOffer={deleteOffer} />
                                    : null
                        }
                    </div>
                </Grid>
            </Grid>
        </>
    );
}

export default HotelOffer;